import CONNECT_KNL from '@/graphql/Website/Integrations/KeuzeNL/ConnectKeuzeNLIntegration.gql';
import { authClient } from '../main'

export default class KeuzeNLResource {
    async connect (websiteId) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: CONNECT_KNL,
            variables: {
                websiteId: websiteId,
            }
        })
    }
}
